import { render, staticRenderFns } from "./CourseDetail.vue?vue&type=template&id=5fe42cda&scoped=true&"
import script from "./CourseDetail.vue?vue&type=script&lang=js&"
export * from "./CourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetail.vue?vue&type=style&index=0&id=5fe42cda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe42cda",
  null
  
)

export default component.exports